<template lang="pug">
v-app-bar.accent
  v-btn.accent(v-on:click="$router.go(-1)", icon, v-if="$dealer.serviceCode")
    v-icon mdi-chevron-left
  v-toolbar-title Route Planner
  v-spacer
  
  
  v-btn.mx-2.accent(text, v-on:click="login", v-if="!$user.email")
    v-icon mdi-login
    span Log in
  v-btn.primary(v-on:click="signup", v-if="!$user.email")
    v-icon mdi-account-plus
    span Sign Up
  v-btn.accent.mx-2(icon, v-on:click="upload", v-if="$user.email")
    v-icon mdi-upload
  v-btn.accent.mx-2(icon, v-on:click="logout", v-if="$user.email")
    v-icon mdi-logout

  v-btn(icon v-if="mobile", v-on:click="toggleMap")
    v-icon mdi-map
  v-btn.accent(icon, v-on:click="openSolarForm")
    v-icon $vuetify.icons.solar
</template>
<script>
import UserManagement from '../mixins/UserManagement';
import {headerBus} from "../main";
export default {
  mixins:[UserManagement],
  data() {
    return {
      settings: this.$dealer.user_settings,
      dialog: false,
    };
  },
  computed: {
    mobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
        case "md":
          return true;
        default:
          return false;
      }
    },
  },
  methods: {
    toggleMap() {
      headerBus.$emit("toggleMap");
    }
  }

};
</script>